import { render, staticRenderFns } from "./hotInformation.vue?vue&type=template&id=9bce06ae&scoped=true&"
import script from "./hotInformation.vue?vue&type=script&lang=js&"
export * from "./hotInformation.vue?vue&type=script&lang=js&"
import style0 from "./hotInformation.vue?vue&type=style&index=0&id=9bce06ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bce06ae",
  null
  
)

export default component.exports